"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PermissionContainer = /** @class */ (function () {
    function PermissionContainer() {
        this.permissions = [];
        this.permissionsDict = {};
        if (PermissionContainer.instance) {
            return PermissionContainer.instance;
        }
        PermissionContainer.instance = this;
    }
    PermissionContainer.prototype.setPermissions = function (permissions) {
        this.permissions = permissions.map(function (name) { return ({ name: name }); }).slice();
        this.permissionsDict = this.permissions.reduce(function (res, permission) {
            var _a;
            return (__assign({}, res, (_a = {}, _a[permission.name] = permission, _a)));
        }, {});
    };
    PermissionContainer.prototype.getPermission = function (name) {
        return this.permissionsDict[name];
    };
    PermissionContainer.prototype.permissionExists = function (name) {
        return !!this.permissionsDict[name];
    };
    return PermissionContainer;
}());
exports.PermissionContainer = PermissionContainer;
//# sourceMappingURL=permission-container.js.map